var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7109 18H27.2109C26.6142 18 26.0419 18.237 25.6199 18.659C25.198 19.0809 24.9609 19.6532 24.9609 20.25V25.875C24.9609 26.4717 25.198 27.044 25.6199 27.466C26.0419 27.8879 26.6142 28.125 27.2109 28.125H29.4609C30.0577 28.125 30.63 27.8879 31.0519 27.466C31.4739 27.044 31.7109 26.4717 31.7109 25.875V18ZM31.7109 18C31.711 16.2176 31.3581 14.4529 30.6727 12.8076C29.9872 11.1624 28.9827 9.66912 27.7172 8.41404C26.4517 7.15897 24.9501 6.16692 23.2992 5.49514C21.6483 4.82335 19.8807 4.48513 18.0984 4.49998C16.3173 4.48699 14.5513 4.82659 12.902 5.49922C11.2527 6.17184 9.75283 7.16418 8.4888 8.41907C7.22476 9.67395 6.22155 11.1666 5.53696 12.8109C4.85238 14.4553 4.49995 16.2188 4.5 18V25.875C4.5 26.4717 4.73705 27.044 5.15901 27.466C5.58097 27.8879 6.15326 28.125 6.75 28.125H9C9.59674 28.125 10.169 27.8879 10.591 27.466C11.0129 27.044 11.25 26.4717 11.25 25.875V20.25C11.25 19.6532 11.0129 19.0809 10.591 18.659C10.169 18.237 9.59674 18 9 18H4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7109 25.875V29.25C31.7109 30.4435 31.2368 31.5881 30.3929 32.432C29.549 33.2759 28.4044 33.75 27.2109 33.75H19.125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarPhone);
export default __webpack_public_path__ + "static/media/earPhone.b77cac330b448ffe3ae1d093df135510.svg";
export { ForwardRef as ReactComponent };